module.exports = "/_next/static/images/eh-4d3df2560dceed63f1372ccad6706e2e.svg";